<template>
  <card>
    <list
      v-if="$store.state.user.sections['report/scorings/week']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="false"
      :setImport="false"
      :exportFields="exportFields"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        // "Результат скоринга": "scored",
      },
      staticFilters: [],
      dateFilter: [],
      filters: [
        // {
        //   key: "partner",
        //   title: "Фильтр по партнерам",
        //   titleKey: "name",
        //   field_key: "partner",
        // },
        // {
        //   key: "shop",
        //   title: "Фильтр по торговым точкам",
        //   titleKey: "name",
        //   field_key: "shop",
        // },
        // {
        //   key: "user",
        //   title: "Фильтр по сотрудникам",
        //   titleKey: "phone",
        //   field_key: "user",
        // },
        {
          key: "organization",
          title: "Фильтр по организациям",
          titleKey: "name",
          field_key: "organization",
          selectKey: "name",
        },
      ],
      params: {},
      val: [],
      modalCreate: "business",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "report/scorings/week",
      setLink: "report/scorings/week",
      columns: [
        {
          key: "week",
          title: "Номер недели / Год",
        },

        {
          key: "order_count",
          title: "Всего создано заказов",
          compare: true,
        },
        {
          key: "transaction_scoring_down",
          title: "Не прошла проверка у партнера",
          compare: true,
          percent: true,
        },
        {
          key: "transaction_count",
          title: "Прошла проверка у партнера",
          compare: true,
          percent: true,
        },
        {
          key: "transaction_stoped",
          title: "После успешной проверки у партнера - не завершили заказ",
          compare: true,
          percent: true,
        },
        {
          key: "transaction_done",
          title: "Выполненные заказы",
          compare: true,
          percent: true,
        },
        {
          key: "transaction_cancel",
          title: "Отмена после оплаты",
          compare: true,
          percent: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
